module.exports = __webpack_public_path__ + "static/media/SU.4323ab2e.png";